export default "__VITE_ASSET__0849de14__"